import request from "@/utils/request"

//获取站点计费模型
export function Get_PowerSite_ChargingConfigById(params) {
  return request({
    url: "Anno.Plugs.DevArchive/Powersite/GetChargingConfigById",
    method: "get",
    params
  })
}
//保存站点计费模型
export function Save_PowerSite_ChargingConfig(data) {
  return request({
    url: "Anno.Plugs.DevArchive/Powersite/SaveChargingConfig",
    method: "post",
    data
  })
}
//发送计费模型
export function Push_PowerSite_ChargingConfig(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/PowerSite/PushChargingConfig",
    method: "post",
    data
  })
}
// 获取所有变压器设备
export function GetAllPowerTransformer() {
  return request({
    url: "Anno.Plugs.DevArchive/PowerTransformer/GetAllList",
    method: "get"
  })
}